// extracted by mini-css-extract-plugin
module.exports = {"form":"Newsletter_form__TDEBx"};